import React from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { useCallback } from 'sb-hooks'
import { links } from 'common/helpers'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const handleClick = ({ hasMarketingCoupon, isGiftSubscriptionActive }) => {
  if (hasMarketingCoupon || !isGiftSubscriptionActive) {
    return actions.models.router.push(links.couponPayment)
  }

  actions.models.router.push(links.giftRedeem)
}

const RedeemButton = (props) => {
  const { id, size, color, fullWidth, weight, hasMarketingCoupon, isGiftSubscriptionActive, dataTestId } = props

  const title = hasMarketingCoupon || !isGiftSubscriptionActive
    ? messages.redeemCoupon
    : messages.redeemGift

  const onClick = useCallback(() => {
    handleClick({ hasMarketingCoupon, isGiftSubscriptionActive })
  }, [ hasMarketingCoupon, isGiftSubscriptionActive ])

  return (
    <Button
      id={id}
      size={size}
      color={color}
      fullWidth={fullWidth}
      title={title}
      weight={weight}
      uppercase
      dataTestId={dataTestId}
      onClick={onClick}
    />
  )
}

export default connect((state) => {
  // TODO refactor RedeemButton for marketing coupon and gift subscription
  const { models: { me: { hasMarketingCoupon, giftSubscription } } } = state

  return {
    hasMarketingCoupon,
    isGiftSubscriptionActive: giftSubscription && !giftSubscription.activated,
  }
})(RedeemButton)
